export const SEGMENTS = [
  { price: 399, title: 'Gen-Z Tees at ₹399', sub: 'Slogan tees that say it like it is' },
  { price: 599, title: 'Oversized Tees at ₹599', sub: 'Street graphics, desi attitude' },
  { price: 799, title: 'Premium Graphic Tees at ₹799', sub: 'Heavyweight cotton, embroidered details' },
  { price: 999, title: 'Kurtas, Punjabis & Sarees at ₹999', sub: 'Everyday ethnic wear', offer: 'b1g1' },
  { price: 1999, title: 'Festive Ethnic Wear at ₹1,999', sub: 'Block prints, tant, Chanderi and more' },
  { price: 3999, title: 'Historical Designs at ₹3,999', sub: 'Kurtas, punjabis & sarees inspired by Indian history', offer: 'b2g1' },
  { price: 5999, title: 'Heritage Masterpieces at ₹5,999', sub: 'Ashoka, Chola, Baluchari and Quit India designs' },
  { price: 7999, title: 'Storytelling Premium at ₹7,999', sub: 'Every piece tells a chapter of India' },
  { price: 9999, title: 'Royal Storytelling at ₹9,999', sub: 'Brocade, zari and silk with a story' },
  { price: 15999, title: 'Hand-Stitched Limited Edition at ₹15,999', sub: 'Banarasi sarees, punjabis & kurtas with historical coins. Only 25 pieces each.' },
];

export const THEMES = {
  independence: { title: 'Indian Independence Movement Collection', tag: 'From Dandi to 15 August 1947', copy: 'Khadi, charkhas, Inquilab and the tricolour. Clothing that honours the people who won India her freedom.', bg: '#0B5D3B' },
  mughal: { title: 'Mughal Empire Limited Collection', tag: 'Gardens, jaalis & gold mohurs', copy: 'Inspired by the gardens of Babur, the jaalis of the Taj and the Peacock Throne of Shah Jahan.', bg: '#7A1F2B' },
  coins: { title: 'Ancient Coins of India: Maurya & Gupta', tag: '2,300 years of Indian coinage', copy: 'Punch-marked karshapanas, Gupta gold dinars and Indo-Greek drachmas, now worn as art.', bg: '#7A5A12' },
  bengal: { title: 'Bengal Heritage Collection', tag: 'Kantha, Baluchari, tant & terracotta', copy: 'From Bishnupur terracotta to Tagore\'s verse. Bengal\'s crafts, woven and stitched by its artisans.', bg: '#9A2D12' },
  temple: { title: 'Temple Art of India', tag: 'Konark, Khajuraho, Chola & Hampi', copy: 'Sun-temple wheels, gopurams and the dancing Nataraja, carried from stone to silk.', bg: '#3D2C6B' },
};

export const OFFER_LABEL = { b1g1: 'Buy 1 Get 1 Free', b2g1: 'Buy 2 Get 1 Free' };

export const TYPES = [['tee', 'T-Shirts'], ['kurta', 'Kurtas'], ['punjabi', 'Punjabis'], ['saree', 'Sarees'], ['kurti', 'Kurtis']];

export const COLLECTION_LABEL = {
  genz: 'Gen-Z Tees', ethnic: 'Ethnic Wear', heritage: 'Historical Designs',
  storytelling: 'Storytelling Premium', limited: 'Limited Edition',
};

export const FREE_SHIP_MIN = 799;
export const SHIPPING_FEE = 49;
export const NO_FEES_LINE = 'All prices inclusive of GST · No platform fee · No processing fee. You pay only the price you see.';

export const PALETTE = [
  { bg: '#FFF1E6', fg: '#C2410C' }, { bg: '#FDECF3', fg: '#BE185D' }, { bg: '#EEF2FF', fg: '#4338CA' },
  { bg: '#E7F8EE', fg: '#15803D' }, { bg: '#FEF9C3', fg: '#A16207' }, { bg: '#F3E8FF', fg: '#7E22CE' },
  { bg: '#E0F2FE', fg: '#0369A1' }, { bg: '#FFE4E6', fg: '#BE123C' }, { bg: '#ECFCCB', fg: '#4D7C0F' },
  { bg: '#FDF2E1', fg: '#92400E' },
];
